import { formatCurrency } from '@dehaat/dds';
import useTranslation from 'next-translate/useTranslation';
import { ComboDiscountType, ComboType, ComboVariant } from '@/models/Combo';
import { ProductListTypeEnum } from '@/utils/analytics/types';
import Paragraph, { VARIANT as PARAGRAPH_VARIANT } from '../../Paragraph';
// import ProductImage from './ProductImage'
import ProductListingImage from '.././ProductListingImage';
import ComboAddToCart from './ComboAddToCart';
interface Props {
  productVariant: ComboVariant;
  listType?: ProductListTypeEnum;
  position?: number;
  componentName?: string;
  componentId?: string | number;
  isWishlist?: boolean;
  product?: ComboType;
}
const ComboVariantCard = ({
  productVariant,
  listType,
  position,
  componentName,
  componentId,
  isWishlist,
  product
}: Props) => {
  const {
    t
  } = useTranslation('products');
  const productName = product?.name || '';
  const productImage = product?.image;
  const discount = Number(productVariant.discount_amount || 0);
  const price = Number(productVariant?.price);
  const discountPercent = Math.round(discount / price * 100);
  return <section className={`bg-white border-neutral-10 rounded shadow-[0_4px_4px_rgba(0,0,0,0.05)]  pr-3 w-full flex items-center 
      }`} data-sentry-component="ComboVariantCard" data-sentry-source-file="ComboVariantCard.tsx">
      <div className="flex items-center">
        <div className="relative flex flex-col items-center">
          <ProductListingImage imageUrl={productImage || null} productName={productName || ''} imageClassName="h-20 w-20" fallbackClassName="h-8 w-8" outOfStockImageClassName="h-20 w-20" data-sentry-element="ProductListingImage" data-sentry-source-file="ComboVariantCard.tsx" />
        </div>
        <Paragraph variant={PARAGRAPH_VARIANT.MEDIUM} className="ml-1 font-medium text-[#33393D] grow-0" data-sentry-element="Paragraph" data-sentry-source-file="ComboVariantCard.tsx">
          {productVariant.applicable_acres ? `${productVariant.applicable_acres} acre pack` : ''}
        </Paragraph>
      </div>
      <div className="flex flex-row flex-1 justify-center lg:justify-start items-center gap-1 lg:ml-6">
        {discount > 0 ? <div className="flex flex-col md:flex-row items-center gap-x-1">
            <p className="font-nato-semibold text-neutral-80 text-center">
              {formatCurrency(price - discount)}
            </p>
            <span className="text-neutral-500 text-sm line-through">
              {formatCurrency(price)}
            </span>

            {productVariant.discount_type === ComboDiscountType.PERCENTAGE && <p className="font-medium text-[#43A314] text-xs">
                ({discountPercent}% {t('sale_off')})
              </p>}
          </div> : <>
            <p className={`font-nato-semibold text-neutral-80  text-center`}>
              {formatCurrency(price - (discount || 0))}
            </p>
            {discount > 0 && <span className="flex flex-row ml-1 text-sm line-through text-ellipsis">
                {formatCurrency(price)}
              </span>}
          </>}
      </div>
      <ComboAddToCart productName={product?.name || ''} productVariant={productVariant} listType={listType} index={position} isDrawerVisible={true} componentName={componentName} componentId={componentId} isWishlist={isWishlist} product={product} btnContainerStyle="max-w-[80px] ml-auto md:max-w-none" data-sentry-element="ComboAddToCart" data-sentry-source-file="ComboVariantCard.tsx" />
    </section>;
};
export default ComboVariantCard;